import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { RouterAccessService } from '../services/router-access.service';

@Directive({
  selector: '[abAccess]'
})
export class AccessDirective implements OnInit {
  @Input('abAccess') url: string;
  @Input() checkAccess: boolean;

  constructor(
    private elementRef: ElementRef,
    private routerAccessService: RouterAccessService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    if (this.checkAccess) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'hidden', '');
      this.routerAccessService.checkRouteAccess(this.url).subscribe(result => {
        if (result.access) {
          this.renderer.removeAttribute(
            this.elementRef.nativeElement,
            'hidden'
          );
        }
      });
    }
  }
}
